import React from 'react'
import {Badge} from '../..'
import { cardData } from '../../../utils/constants';

import './gallery.css'

const Gallery = () => {
    const [stopScroll, setStopScroll] = React.useState(false);

  return (
    <>
        <div className='gallery-wrapper'>
            <Badge title="Gallery" />
            <div className='gallery-container'>
                <div className="gallery-carousel-wrapper" onMouseEnter={() => setStopScroll(true)} onMouseLeave={() => setStopScroll(false)}>
                    <div className="gallery-carousel-faded-left" />
                    <div className="gallery-carousel-slides-cover gallery-marquee-inner" style={{ animationPlayState: stopScroll ? "paused" : "running", animationDuration: cardData.length * 2500 + "ms" }}>
                        <div className="gallery-carousel-slides">
                            {[...cardData, ...cardData].map((card, index) => {

                                return (
                                    <div key={index} className="gallery-carousel-image-wrapper">
                                        <img src={card.image} alt="card" className="gallery-carousel-images" />
                                        <div className="gallery-carousel-image-text">
                                            <p className="gallery-carousel-image-title">{card.title}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="gallery-carousel-faded-right" />
                </div>
            </div>
        </div>
    </>
  )
}

export default Gallery